import React, { Component } from 'react';
import './ExpandCollapse.scss';
import expandLess from '../../../assets/images/expand-less.svg';
import expandMore from '../../../assets/images/expand-more.svg';

class ExpandCollapse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expand: true,
      oppositeExpand: false,
      currentlyExpanded: 'collapse1',
    };
    this.toggleShow = this.toggleShow.bind(this);
  }

  toggleShow(name) {
    const { currentlyExpanded, expand } = this.state;
    if (currentlyExpanded !== name) {
      this.setState({
        expand: true,
        currentlyExpanded: name,
        oppositeExpand: false,
      });
    } else {
      this.setState({
        expand: !expand,
        currentlyExpanded: name,
        oppositeExpand: false,
      });
    }
  }
  render() {
    const { details } = this.props;
    const { expand, currentlyExpanded, oppositeExpand } = this.state;
    return (
      <div>
        {details.map(({ className, content, heading, show }) => {
          return (
            <div key={className}>
              {show && (
                <div className="expanded-collapse">
                  <div
                    className="expanded-collapse-heading-row"
                    onClick={() => {
                      this.toggleShow(className);
                    }}
                  >
                    <div className="expanded-collapse-heading">{heading}</div>
                    <div className="expanded-collapse-image">
                      {(expand && currentlyExpanded === className) ||
                      (oppositeExpand && currentlyExpanded !== className) ? (
                        <img alt="" src={expandLess} />
                      ) : (
                        <img alt="" src={expandMore} />
                      )}
                    </div>
                  </div>
                  <div className="expanded-collapse-description">
                    {((expand && currentlyExpanded === className) ||
                      (oppositeExpand && currentlyExpanded !== className)) &&
                      content}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  }
}

export default ExpandCollapse;
